import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

/**
 * Set the isSelected bit in the copilot theme store
 * @param status the theme copilot is selected bit
 */
const setIsCopilotThemeSelectedMutator: (isSelected: boolean) => void = mutatorAction(
    'setIsCopilotThemeSelected',
    (isSelected: boolean): void => {
        getStore().options.isSelected = isSelected;
    }
);
export default setIsCopilotThemeSelectedMutator;
